import { IWant } from 'shared/types/Want';
import { bugsnag } from 'shared/utils/services/bugsnag';
import { requestService } from 'shared/utils/services/requestService';

export const getWants = async (id: number): Promise<IWant[]> => {
  if (!id) return [];

  try {
    const wantedProducts = await requestService({
      url: `/web-api/v1/wants?productTemplateId=${id}`,
      method: 'GET',
    });

    const { wants } = wantedProducts;
    return wants;
  } catch (error) {
    bugsnag(error, { context: 'PDP: Error fetching wants' });
    return [];
  }
};
